/**
 * 归因模块配置常量。
 * 修改覆盖策略或站内域排除表时改此文件（服务端 constants.js 需同步）。
 */

/** Session cookie 选项：无 maxAge/expires */
export const ATTRIBUTED_ENTRY_SESSION_COOKIE_OPTIONS = {} as const;

/** 同一 session 内是否允许覆盖已有 entry */
export const ATTRIBUTED_ENTRY_OVERWRITE_POLICY = {
  allowOverwriteExisting: true
} as const;

/** 站内 referrer hostname 后缀排除表 */
export const INTERNAL_REFERRER_HOST_SUFFIXES = [
  'sayweee.com',
  'sayweee.net',
  'masgusto.com',
  'masgusto.net',
  'sayweeecdn.com',
  'localhost'
] as const;
